import {checkEmail} from "@k/global/globalUtils";
import {Ref} from "vue";
import {EnumDictionary} from "@k/js/delme_globals";

export class FormValidation {

    private static validateEmail = (supposedEmail:Ref<string>) => checkEmail(supposedEmail.value) === "valid";
    private static validateNotEmpty = (ref:Ref<string>) => ref.value !== "";
    public static validateValueIsTrue = (ref:Ref<boolean>) => ref.value;

    private static checkRequiredFields(requiredFields:EnumDictionary<string, Ref<string>>):string[] {
        const out = [] as string[];
        for(const name in requiredFields) {
            if(!FormValidation.validateNotEmpty(requiredFields[name])) {
                out.push(name);
            }
        }
        return out;
    }

    private static checkboolsThatShouldBeTrue(boolsThatShouldBeTrue:EnumDictionary<string, Ref<boolean>>):string[] {
        const out = [] as string[];
        for(const name in boolsThatShouldBeTrue) {
            if(!FormValidation.validateValueIsTrue(boolsThatShouldBeTrue[name])) {
                out.push(name)
            }
        }
        return out;
    }

    private static checkEmailFields(emailFields:EnumDictionary<string, Ref<string>>):string[] {
        const out = [] as string[];
        for(const name in emailFields) {
            if(!FormValidation.validateEmail(emailFields[name])) {
                out.push(name);
            }
        }
        return out;
    }

    public static validate(emailFields:EnumDictionary<string, Ref<string>>, requiredFields:EnumDictionary<string, Ref<string>>, boolsThatShouldBeTrue:EnumDictionary<string, Ref<boolean>>) {
        return FormValidation.checkEmailFields(emailFields)
            .concat(FormValidation.checkRequiredFields(requiredFields))
            .concat(FormValidation.checkboolsThatShouldBeTrue(boolsThatShouldBeTrue));
    }

}

export function getvaluesFromRefObject(refObject:EnumDictionary<string, Ref>) {
    const out = {};
    for(const name in refObject) {
        out[name] = refObject[name].value;
    }
    return out;
}
